const SILENT_TOKEN_KEY = "freelancerSilentToken";

export const getUrlAuthToken = () => {
  try {
    return new URLSearchParams(window.location.search).get("token") || "";
  } catch (e) {
    return "";
  }
};

export const clearUrlAuthToken = () => {
  try {
    const url = new URL(window.location.href);
    if (!url.searchParams.has("token")) return;
    url.searchParams.delete("token");
    const next =
      url.pathname + (url.searchParams.toString() ? `?${url.searchParams}` : "");
    window.history.replaceState({}, "", next);
  } catch (e) {
    // ignore
  }
};

export const getStoredAuthToken = () => {
  try {
    const admin = localStorage.getItem("admin");
    if (admin) {
      const authData = JSON.parse(admin).auth;
      return JSON.parse(authData).session.token || "";
    }

    const session = localStorage.getItem("session");
    if (session) {
      const parsed = JSON.parse(session);
      return parsed?.token || "";
    }
  } catch (e) {
    // ignore parse errors
  }
  return "";
};

export const getSilentAuthToken = () => {
  try {
    return sessionStorage.getItem(SILENT_TOKEN_KEY) || "";
  } catch (e) {
    return "";
  }
};

export const persistSilentAuthToken = (token) => {
  if (!token) return;
  try {
    sessionStorage.setItem(SILENT_TOKEN_KEY, token);
  } catch (e) {
    // ignore storage errors
  }
};

const decodeJwtPayload = (token) => {
  if (!token || typeof token !== "string") return null;
  const parts = token.split(".");
  if (parts.length < 2) return null;
  try {
    const base64 = parts[1].replace(/-/g, "+").replace(/_/g, "/");
    const json = atob(base64);
    return JSON.parse(json);
  } catch (e) {
    return null;
  }
};

export const getTrainerIdFromToken = (token) => {
  const payload = decodeJwtPayload(token);
  if (!payload) return "";
  return payload.trainer_id || payload.trainerId || "";
};

/** Returns true if JWT has exp claim and it is in the past (30s buffer). */
export const isJwtExpired = (token) => {
  const payload = decodeJwtPayload(token);
  if (!payload?.exp) return false;
  const expMs = Number(payload.exp) * 1000;
  if (!Number.isFinite(expMs)) return false;
  return Date.now() >= expMs - 30000;
};

/** Session token first — URL token is only for get-freelancer-data exchange. */
export const getAuthToken = () => {
  const sessionToken = getStoredAuthToken();
  if (sessionToken) return sessionToken;

  const silentToken = getSilentAuthToken();
  if (silentToken) return silentToken;

  return getUrlAuthToken();
};
